import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import Switch from './types/StyleSwitch';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.home.actions';
import * as actionsforms from '../../../actions/api.form.actions';

import { BlueRightArrowIcon } from '../../../images/icons/WrapSvg';

class Item extends React.Component {
    state = {
        desactivado: false,
    };

    calculePercentage = (max, score) => {
        if (max > 0) {
            return isNaN(score / max) ? '-%' : ((score / max) * 100).toFixed(0) + '%';
        } else {
            return '-%';
        }
    };

    static getDerivedStateFromProps(props, state) {
        const { data } = props;
        if (data !== state.data) {
            state.desactivado = data.desactivado;
            state.data = data;
            return state;
        }
        return null;
    }

    hasPending = (pending, name) => {
        return (
            pending
                .map((p) => {
                    return p.tab;
                })
                .indexOf(name) >= 0
        );
    };

    handleClick = (event) => {
        const { params } = this.props;
        const { data } = this.state;

        this.props.history.push(
            `/processes/${params.family}/${params.process}/${params.instance}/${data.codigo}`,
        );
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked });
    };

    render() {
        const { last, active, editable } = this.props;
        const { data } = this.state;

        if (data && !data.oculto && data.hijos && data.hijos.length > 0) {
            return (
                <div
                    onClick={this.handleClick}
                    className={classNames(
                        'hand flex_full_row ',
                        active
                            ? last
                                ? 'activelast'
                                : 'active'
                            : last
                            ? 'noshadow'
                            : 'shadow_down',
                    )}
                >
                    <div
                        className={classNames(
                            'flex_auto_column padding_left_12 padding_top_12',
                            active ? ' bg_bluish' : '',
                        )}
                    ></div>
                    <div className="flex_full_column padding_left_12 padding_top_12">
                        <div className={'flex_auto_row '}>
                            <div className={'margin_bottom_5 flex_full_row'}>
                                <span className={'barlow_medium c_dark_grey_blue upper'}>
                                    {data.nombre}
                                </span>
                            </div>
                        </div>
                        <div className={'flex_full_row padding_bottom_9 align_center'}>
                            <div className={'flex_full_column'} />
                            <div
                                className={
                                    'flex_normal_column  elements_center itemcheck_labels_number'
                                }
                            >
                                <span
                                    className={
                                        'barlowcondensed_light_percentage c_black_two text_align_center nowrap'
                                    }
                                >
                                    {this.calculePercentage(
                                        data.puntuacionposible,
                                        data.puntuacionefectiva,
                                    )}
                                </span>
                            </div>
                            <div
                                className={'flex_fixed_column_88  elements_center padding_left_12'}
                            >
                                <Switch
                                    data={data}
                                    disabled={!editable || data.sololectura || !data.desactivable}
                                    desactivado={data.desactivado}
                                    value={data.pendiente ? undefined : true}
                                    onChange={this.handleDeactive}
                                />
                            </div>
                            <div className={'flex_normal_column elements_center margin_right_2'}>
                                <BlueRightArrowIcon color="primary" />
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

Item.propTypes = {
    history: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions, actionsforms), dispatch);
}

export default connect(
    undefined,
    mapDispatchToProps,
)(withRouter(Item));



// WEBPACK FOOTER //
// ./src/components/complex/forms/Item.js